export const PUSAT_INFORMASI_SEARCH_BASE_URL =
  'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/search?utf8=%E2%9C%93&query='

export const GUIDANCE_DOCUMENTS_URL =
  'https://drive.google.com/drive/folders/1p7JrPQkHNIJIf2tjMefL_eNJFa2BUWY1'

export const KURIKULUM_MERDEKA_CONTENTS = [
  {
    title: 'Garis Besar Kurikulum Merdeka',
    subtitle: 'Prinsip Dasar, Tujuan, Perbandingan dengan Kurikulum Sebelumnya',
    children: [
      {
        title:
          'Pembelajaran Sesuai dengan Tingkat Kesiapan dan Pemahaman Peserta Didik',
        icon: '/icon/km-stairs.png',
        href: 'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/14142735013145-Pengajaran-Sesuai-dengan-Tingkat-Kemampuan-Peserta-Didik',
      },
      {
        title: 'Pembagian Tanggung Jawab Pusat, Daerah, dan Satuan Pendidikan',
        icon: '/icon/km-shake-hands.png',
        href: 'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/14143000505881-Pengorganisasian-Pelaksanaan-Pembelajaran',
      },
      {
        title: 'Perbandingan Kurikulum Merdeka dengan Kurikulum Sebelumnya',
        icon: '/icon/km-question.png',
        href: 'https://kurikulum.kemdikbud.go.id/perbandingan-kurikulum',
      },
      {
        title: 'Struktur Kurikulum Merdeka',
        icon: '/icon/km-book.png',
        href: 'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/14179832698137-Struktur-Kurikulum-Merdeka-dalam-Setiap-Fase',
      },
    ],
  },
  {
    title: 'Pembelajaran dan Asesmen',
    subtitle:
      'Memahami CP, Menyusun ATP, Merencanakan Pembelajaran dan Asesmen',
    children: [
      {
        title: 'CP dan ATP',
        icon: '/icon/km-question.png',
        href: 'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/sections/14150001996185-Pembelajaran-Asesmen',
      },
      {
        title:
          'CP dan Contoh ATP yang sesuai dengan Jenis, Tingkat Pendidikan, dan Mata Pelajaran',
        icon: '/icon/km-documents.png',
        href: `${process.env.NEXT_PUBLIC_BASE_URL}/kurikulum/referensi-penerapan/capaian-pembelajaran/`,
      },
      {
        title: 'Perencanaan Pembelajaran dan Asesmen',
        icon: '/icon/km-search.png',
        href: 'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/30190796003737-Merencanakan-Pembelajaran-dan-Asesmen',
      },
    ],
  },
  {
    title: 'Projek Penguatan Profil Pelajar Pancasila',
    subtitle: 'Pengertian, Dimensi, Perencanaan dan Pelaksanaan',
    children: [
      {
        title: 'Pengertian dan Penerapan Profil Pelajar Pancasila',
        icon: '/icon/km-documents-2.png',
        href: 'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/14145044257945-Pengertian-Profil-Pelajar-Pancasila',
      },
      {
        title: 'Dimensi, Elemen, Sub Elemen Profil Pelajar Pancasila',
        icon: '/icon/km-documents.png',
        href: `${process.env.NEXT_PUBLIC_BASE_URL}/kurikulum/referensi-penerapan/profil-pelajar-pancasila/fase-a/`,
      },
      {
        title: 'Pengertian Projek Penguatan Profil Pelajar Pancasila',
        icon: '/icon/km-documents-2.png',
        href: 'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/30194934594585-Pengertian-Projek-Penguatan-Profil-Pelajar-Pancasila',
      },
      {
        title:
          'Perencanaan dan Pelaksanaan Projek Penguatan Profil Pelajar Pancasila',
        icon: '/icon/km-stairs.png',
        href: 'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/14154290859801-Penerapan-Profil-Pelajar-Pancasila-di-Lingkungan-Satuan-Pendidikan',
      },
      {
        title: 'Contoh Modul Projek Penguatan Profil Pelajar Pancasila',
        icon: '/icon/km-gallery.png',
        href: `${process.env.NEXT_PUBLIC_BASE_URL}/perangkat-ajar/search?toolkit_type=modul-projek&phase=Fondasi&phaseGroup=Umum&from=search`,
      },
    ],
  },
  {
    title: 'Kurikulum Satuan Pendidikan',
    subtitle: 'Fungsi, Prinsip, Komponen, dan Contoh Pengembangan',
    children: [
      {
        title: 'Fungsi, Prinsip, dan Komponen Kurikulum Satuan Pendidikan',
        icon: '/icon/km-documents-2.png',
        href: 'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/14179979320089-Komponen-Komponen-dalam-KOSP',
      },
      {
        title: 'Panduan dan Contoh Pengembangan Kurikulum Satuan Pendidikan',
        icon: '/icon/km-gallery.png',
        href: 'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/14179956485017-Panduan-dan-Contoh-Perumusan-KOSP',
      },
    ],
  },
]

export const FACT_AND_MISCONCEPTION_CONTENTS = [
  {
    title:
      'Benarkah Kurikulum Merdeka itu bebas tanpa rambu-rambu arah yang jelas?',
    content: (
      <>
        Nilai Merdeka Belajar dalam implementasi Kurikulum Merdeka berpusat pada{' '}
        <strong>kemampuan mandiri dan reflektif dalam pembelajaran</strong>.
        <br />
        <br />
        Proses pembelajaran di Kurikulum Merdeka ditujukan untuk mewujudkan
        pembelajaran yang bersifat holistik dan kontekstual sehingga
        pembelajaran semakin bermanfaat dan bermakna bagi peserta didik, bukan
        hanya sekedar hafal materi saja.
        <br />
        <br />
        Prinsip-prinsip pembelajaran yang tertuang dalam panduan-panduan
        Kurikulum Merdeka dapat digunakan sebagai rambu-rambu oleh Satuan
        Pendidikan untuk mengimplementasikan Kurikulum Merdeka berdasarkan
        tingkat kesiapan masing-masing.
      </>
    ),
  },
  {
    title:
      'Adakah pelatihan berjenjang dalam Kurikulum Merdeka seperti di Kurikulum 2013?',
    content: (
      <>
        <strong>Tidak ada pelatihan berjenjang</strong>, karena proses belajar
        bisa dilakukan di Pelatihan Mandiri melalui Platform Merdeka Mengajar
        (PMM) dan komunitas belajar.
        <br />
        <br />
        Bila diperlukan pengayaan pembelajaran bisa melalui seri webinar,
        bertanya melalui help desk, mengundang Narasumber Berbagi Praktik Baik
        dan pendampingan bagi mitra pembangunan.
        <br />
        <br />
        Tidak adanya pelatihan berjenjang mencegah untuk meminimalisir
        miskonsepsi dan informasi yang tidak utuh.
      </>
    ),
  },
  {
    title:
      'Apakah implementasi Kurikulum Merdeka hanya fokus untuk mendorong pembelajaran yang berorientasi pada pengembangan kemampuan TIK?',
    content: (
      <>
        <strong>
          Tidak. Fokus dari Kurikulum Merdeka adalah transformasi pembelajaran
          dan perubahan paradigma pembelajaran yang berpusat pada peserta didik.
        </strong>
        &nbsp;Dengan melakukan asesmen awal pembelajaran dan diferensiasi proses
        belajar, anak dapat menggali manfaat dan makna dari proses pembelajaran
        yang dilaluinya, termasuk melalui penggunaan TIK.
      </>
    ),
  },
]
